<template>
  <button
    :type="type"
    @click="$emit('click')"
    :class="{
      'ui-button--pill': pill,
      'ui-button--block': block,
      [`ui-button--${size}`]: true,
      [`ui-button--${variant}`]: true,
    }"
    :disabled="disabled"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    variant: {
      type: String,
      default: 'primary',
    },
    pill: {
      type: Boolean,
      default: false,
    },
    block: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'button',
    },
    size: {
      type: String,
      default: 'md',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/variables.scss';

.ui-button--primary,
.ui-button--outline-dark,
.ui-button--outline-primary {
  outline: none;
  cursor: pointer;
  min-width: 80px;
  border: 1px solid;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease-in-out;

  & > *:last-child { margin-right: 0; }

  &:focus {
    color: $white;
    background-color: $primary;
  }

  &:disabled {
    cursor: not-allowed;
  }
}

.ui-button--outline-dark {
  color: $black;
  border-color: $dark-gray;
  background-color: $white;
}

.ui-button--primary {
  color: $white;
  border-color: $white;
  background-color: $primary;
}

.ui-button--outline-primary {
  color: $primary;
  border-color: $primary;
  background-color: $white;
}

.ui-button--sm {
  height: 36px;
  font-size: 16px;
  border-radius: 5px;
  padding: 0 16px;

  & > * { margin-right: 5px; }
}

.ui-button--md {
  height: 44px;
  font-size: 18px;
  border-radius: 8px;
  padding: 0 18px;

  & > * { margin-right: 8px; }
}

.ui-button--lg {
  height: 52px;
  border-radius: 8px;
  font-size: 20px;
  padding: 0 32px;

  & > * { margin-right: 8px; }
}

.ui-button--pill {
  border-radius: 20px;
}

.ui-button--block {
  width: 100%;
}
</style>
